<template>
  <el-dialog :visible.sync="visible" :title="type==='categoryName'?'修改分类':'修改状态'" width="500px" :before-close="close">
    <div v-if="type === 'categoryName'" class="f--c">
      <div style="flex-shrink: 0">版型分类：</div>
      <!-- <el-input size="medium" v-model="categoryName" placeholder="请输入版型标签" maxlength="50" show-word-limit @input="handleInput"></el-input> -->
      <el-select v-model="categoryName" size="medium" placeholder="请选择版型分类" style="width:300px;">
        <el-option v-for="item in categoryNames" :key="item.categoryName" :label="item.categoryName" :value="item.categoryName" />
      </el-select>
    </div>
    <div v-else class="f--c">
      <div style="flex-shrink: 0">版型状态：</div>
      <el-select v-model="status" size="medium" placeholder="请选择版型状态">
        <el-option label="在售" :value="1" />
        <el-option label="下架" :value="0" />
        <el-option label="缺货" :value="4" />
      </el-select>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button :loading="loadingBtn" type="primary" size="medium" @click="confirm">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
export default {
  props: {
    categoryNames: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      visible: false,
      type: 'categoryName',
      categoryName: '',
      status: undefined,
      loadingBtn: false,
      selection: []
    }
  },
  methods: {
    show(type, selection) {
      this.visible = true
      this.type = type
      this.selection = selection
    },

    close() {
      this.clear()
      this.visible = false
    },

    clear() {
      this.categoryName = ''
      this.status = undefined
    },

    confirm() {
      if (this.type === 'categoryName' && !this.categoryName) {
        return this.$message.warning('请选择版型分类')
      }
      if (this.type === 'status' && (!this.status && this.status !== 0)) {
        return this.$message.warning('请选择版型状态')
      }
      if (this.selection.some(t => t.infoMissing) && this.status === 1) {
        return this.$message.warning('有版型资料信息缺失，无法上架！')
      }
      if (this.type === 'categoryName' && this.selection.some(t => t.firstTimeOnShelves)) {
        return this.$message.warning('有无法修改的分类，请重新选择！')
      }
      this.loadingBtn = true
      API[this.type === 'categoryName' ? 'editCustomModelCategoryName' : 'editCustomModelStatus']({
        ids: this.selection.map(t => t.id),
        categoryName: this.categoryName || undefined,
        status: (this.status || this.status === 0) ? this.status : undefined
      }).then(({ code, message }) => {
        if (code !== 10000) return this.$message.error(message)
        this.$message.success('修改成功')
        this.close()
        this.$emit('setSuccess')
      }).finally(() => {
        this.loadingBtn = false
      })
    },
    // 只能输入英文和数字
    handleInput(e) {
      this.categoryName = e.replace(/[^a-zA-Z0-9 ]+/g, '').trim()
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
